// removed by extract-text-webpack-plugin
module.exports = {"hidden":"ZfTMz","visuallyhidden":"_3ADzm","hide-text":"_3lGcP","center":"GH8kT","noprint":"_1KMiW","listItem":"_3vdqy","authorList":"fxN10","image":"dPT4P","root":"_3aMu5 _25KE7","description":"_19SJ6"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-byline/styles/default.scss
 ** module id = 990
 ** module chunks = 2
 **/